/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { registerDecorator } from 'class-validator';
export function IsAfterDateOrEqual(property, validationOptions) {
    return function (object, propertyName) {
        registerDecorator({
            name: 'IsAfterDateOrEqual',
            target: object.constructor,
            propertyName: propertyName,
            constraints: [property],
            options: validationOptions,
            validator: {
                validate(propertyValue, args) {
                    const otherDate = args.object[args.constraints[0]];
                    return propertyValue.valueOf() >= otherDate.valueOf();
                },
                defaultMessage(args) {
                    return `"${args.property}" must be after "${args.constraints[0]}"`;
                }
            }
        });
    };
}
//# sourceMappingURL=is-after.js.map